<template>
  <v-row class="pa-6">
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1">Brand Rx Claims</div>
          <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :sort-by="'EFFECTIVE_DATE'"
          :sort-desc="true"
          :items="provider_data"
          :search="search"
        >
          <template v-slot:item.AMOUNT_DEC="{ item }">
            {{ item.AMOUNT }}
          </template>

          <template v-slot:no-data> No Claims </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Rx',
  props: ['provider', 'insurance', 'startDate', 'endDate'],
  data() {
    return {
      search: '',
      loading: false,
      headers: [
        {
          text: 'Claim ID',
          sortable: false,
          value: 'RX_CLAIM_ID',
        },
        { text: 'Claim Date', value: 'EFFECTIVE_DATE' },
        { text: 'Patient Name', value: 'MEMBER_NAME' },
        { text: 'Drug Name', value: 'DRUG_NAME' },
        { text: 'Qty', value: 'QTY' },
        { text: 'Prescriber', value: 'PRESCRIBER_NAME' },
        { text: 'Prescriber NPI', value: 'PRESCRIBER_NPI' },
        { text: 'Interchange Drug', value: 'INTERCHANGE_DRUG' },
        { text: 'Cost', value: 'AMOUNT_DEC' },
      ],
      provider_data: [],
    };
  },
  mounted() {
    this.getClaims();
  },
  methods: {
    async getClaims() {
      this.provider_data = [];
      this.loading = true;

      await axios
        .get(
          `api/provider/claims/rx/${this.insurance}/${this.provider}/${this.startDate}/${this.endDate}`
        )
        .then((response) => {
          this.provider_data = response.data;
          this.loading = false;
        });
    },
  },
  watch: {
    async startDate() {
      this.getClaims();
    },
    async endDate() {
      this.getClaims();
    },
  },
};
</script>
